/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable no-undef */

import Explorer from './elements/explorer';
import HtmlSanitizer from './helpers/sanitizer';
import Config from './helpers/configs';

const urlSearchParams = new URLSearchParams( window.location.search );

/**
 * All Snapshot Pages.
 */
const setSeen = () => {
	const nonce = snapshotReact.requestsData.pluginRequests.nonce;
	fetch( `${ ajaxurl }?action=snapshot_set_started_seen&_ajax_nonce=${ nonce }` )
		.then( ( response ) => response.json() )
		.then( ( data ) => data )
		.catch( ( err ) => {
			console.error( err );
		} );
};

const manualApply = document.querySelector( '.sui-welcome-apply-configs-redirect' );
if ( manualApply ) {
	manualApply.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		const el = e.target;
		const url = el.getAttribute( 'href' );
		setSeen();
		window.location.href = url;
	} );
}
const isEmpty = ( label ) => {
	return ( '' === label || null === label || 'undefined' === label ) ? true : false;
};

const openNotice = ( args ) => {
	if ( ! ( 'message' in args ) || isEmpty( args.message ) ) {
		// Message must be set and mustn't be empty.
		console.error( 'Cannot display a notice without message' );
		return;
	}

	let icon_class = '';

	switch ( args.type ) {
		case 'success':
			icon_class = 'check-tick';
			break;

		case 'error':
		case 'warning':
			icon_class = 'warning-alert';
			break;

		case 'info':
		default:
			icon_class = 'info';
			break;
	}

	const options = {
		icon: icon_class,
		type: args.type
	};

	if ( args.dismissible ) {
		options.dismiss = { show: true };
	}

	if ( args.autoclose ) {
		options.autoclose = { timeout: args.autoclose };
	} else {
		options.autoclose = { show: false };
	}

	const $suiHeader = document.querySelector( '.sui-header' );
	const noticeId = ( 'id' in args ) ? args.id : 'snapshot-notice-' + Math.random().toString( 36 ).substr( 2, 9 );
	let $noticesWrapper = document.querySelector( '.sui-floating-notices' );
	const $notice = document.createElement( 'div' );

	if ( ! $noticesWrapper ) {
		$noticesWrapper = document.createElement( 'div' );
		$noticesWrapper.setAttribute( 'class', 'sui-floating-notices' );
	}
	$suiHeader.insertBefore( $noticesWrapper, $suiHeader.childNodes[ 0 ] );

	$notice.setAttribute( 'id', noticeId );
	$notice.setAttribute( 'role', 'alert' );
	$notice.setAttribute( 'aria-live', 'assertive' );
	$notice.setAttribute( 'class', 'sui-notice' );

	$noticesWrapper.appendChild( $notice );

	const noticeContent = `<p>${ args.message }</p>`;
	SUI.openNotice( noticeId, noticeContent, options );

	return noticeId;
};

const showWhatsNewModal = () => {
	if ( document.querySelector( '#snapshot-whats-new-modal' ) ) {
		window.SUI.openModal( 'snapshot-whats-new-modal', window );
		const nonce = document.querySelector( '#_wpnonce-whats_new_seen' ).value;
		const formData = new FormData();
		formData.append( '_wpnonce', nonce );
		fetch( `${ ajaxurl }?action=snapshot-whats_new_seen`, {
			method: 'POST',
			credentials: 'same-origin',
			body: formData
		} );
	}
};

const checkRegion = (data) => {
	const checkRegionForm = new FormData();
	checkRegionForm.append( 'action', 'snapshot_check_region' );
	checkRegionForm.append( '_ajax_nonce', data.nonce );
	checkRegionForm.append( 'id', data.configId );

	return fetch( ajaxurl, {
		method: 'POST',
		credentials: 'same-origin',
		body: checkRegionForm,
	} );
};


let applying = false;

/**
 * Apply the configs.
 *
 * @param {FormData}          data
 * @param {HTMLButtonElement} el
 *
 * @return {void}
 */
const applyConfig = ( data, el ) => {
	const applied = fetch( ajaxurl, {
		method: 'POST',
		credentials: 'same-origin',
		body: data,
	} );
	applied
		.then( ( response ) => response.json() )
		.then( ( result ) => {
			if ( result.success ) {
				window.SUI.closeModal();
				let msg = snapshotReact.config_applied;
				msg = msg.replace( '{configName}', `<strong>${ result.data.name }</strong>` );
				const noticeArgs = {
					message: msg,
					type: 'success',
					dismissible: true
				};
				setSeen();
				openNotice( noticeArgs );
				showWhatsNewModal();
			} else if ( 'password_required' === result.data.error ) {
				SUI.closeModal();
				const passModal = document.querySelector( '#snapshot-confirm-wpmudev-password-modal' );
				if ( passModal ) {
					passModal.querySelector( '[name=what]' ).value = 'apply_config_' + result.data.preset.id;
					SUI.openModal( 'snapshot-confirm-wpmudev-password-modal', window );

					const nonce = document.createElement( 'input' );
					nonce.setAttribute( 'type', 'hidden' );
					nonce.setAttribute( 'id', 'snapshot-confirm-password-nonce-field' );
					nonce.setAttribute( 'value', result.data._ajax_nonce );

					const preset = document.createElement( 'input' );
					preset.setAttribute( 'type', 'hidden' );
					preset.setAttribute( 'id', 'snapshot-apply-config-id' );
					preset.setAttribute( 'value', result.data.preset.id );

					passModal.querySelector( '.sui-form-field' ).appendChild( nonce );
					passModal.querySelector( '.sui-form-field' ).appendChild( preset );
				}
			} else if ( 'region_mismatch' === result.data.error ) {

			}
			el.classList.remove( 'applying' );
			applying = false;
		} )
		.catch( ( err ) => {
			el.classList.remove( 'applying' );
			applying = false;
			console.error( err );
		} );
};

const applyConfigLink = document.querySelector( '.sui-welcome-apply-configs' );
if ( applyConfigLink ) {
	applyConfigLink.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		const el = e.target;
		if ( applying ) {
			return;
		}

		applying = true;

		const configId = 1;
		const data = {
			nonce: el.getAttribute( 'data-nonce' ),
			configId,
		};
		el.classList.add( 'applying' );

		const check = checkRegion( data );
		check
			.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( ! result.success || result.data.message === 'region_mismatch' ) {
					// Display the region mismatch modal confirmation
					SUI.closeModal();
					const sel = document.querySelector( '#snapshot-configs-apply-region-change-modal' );
					sel.querySelector( '.snapshot-apply-config__confirm-region-change' ).setAttribute( 'data-config_id', configId );
					sel.querySelector( '.snapshot-apply-config__confirm-region-change' ).setAttribute( 'data-nonce', result.data.nonce );
					const replaced = sel.innerHTML.replace('{{config_name}}', result.data.config_name );
					sel.innerHTML = replaced;
					SUI.openModal( 'snapshot-configs-apply-region-change-modal', window );

					applying = false;
					return;
				}

				// We're not applying the config yet.
				if ( result.data.message === 'region_match' ) {
					const applyConfigForm = new FormData();
					applyConfigForm.append( 'action', 'snapshot_apply_config' );
					applyConfigForm.append( 'id', 1 );
					applyConfigForm.append( '_ajax_nonce', result.data.nonce );
					applyConfig( applyConfigForm, el );
				}
			} )
			.catch( (err) => {
				console.error( err );
			});
	} );
}

/**
 * Get all stored Snapshot configs from the Hub.
 *
 * @return {Promise} Promise object.
 */
const getHubConfigs = () => {
	const packageId = snapshotReact.requestsData.pluginData.id;
	const apiKey = snapshotReact.requestsData.apiKey;
	let uri = snapshotReact.requestsData.hubBaseURL;
	uri += `?package_id=${ packageId }`;

	return fetch( uri, {
		method: 'GET',
		credentials: 'same-origin',
		headers: {
			'Content-Type': ' application/json',
			Authorization: `Basic ${ apiKey }`
		},
	} );
};

/**
 * Sync configs from the Hub.
 *
 * @param {Object} configs
 *
 * @return {Promise} Promise Object
 */
const syncConfigs = ( configs ) => {
	const formData = new FormData();
	formData.append( 'configs', JSON.stringify( configs ) );
	formData.append( 'action', 'snapshot_sync_configs' );
	formData.append( '_ajax_nonce', snapshotReact.requestsData.pluginRequests.nonce );

	return fetch( SnapshotAjax.ajaxurl, {
		method: 'POST',
		credentials: 'same-origin',
		body: formData
	} );
};

const loadHubConfigs = document.querySelector( '.sui-welcome-load-hub-configs' );
if ( loadHubConfigs ) {
	loadHubConfigs.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		const el = e.target;

		if ( applying ) {
			return;
		}

		const configs = getHubConfigs();

		applying = true;
		el.classList.add( 'applying' );
		configs
			.then( ( response ) => response.json() )
			.then( ( res ) => {
				if ( res ) {
					const allConfigs = syncConfigs( res );
					allConfigs
						.then( ( data ) => data.json() )
						.then( ( result ) => {
							if ( result.success ) {
								const nextModal = el.getAttribute( 'data-slide-to' );
								const modal = document.querySelector( `#${ nextModal }` );
								const listEl = modal.querySelector( '#snapshot-configs--hub' );

								for ( const newRes in result.data ) {
									const data = result.data;
									const config = data[ newRes ];
									const opt = document.createElement( 'OPTION' );
									opt.setAttribute( 'value', config.id );
									opt.innerHTML = HtmlSanitizer.SanitizeHtml( config.name );
									listEl.appendChild( opt );
								}

								SUI.slideModal( nextModal );
								el.classList.remove( 'applying' );
							}
						} )
						.catch( ( err ) => {
							console.error( err );
						} );
				} else {
					console.log();
				}

				applying = false;
			} )
			.catch( ( err ) => {
				console.error( err );
				applying = false;
			} );
	} );
}

const hubConfigsForm = document.querySelector( '#snapshot-apply-config--form' );
if ( hubConfigsForm ) {
	hubConfigsForm.addEventListener( 'submit', ( e ) => {
		e.preventDefault();

		if ( applying ) {
			return;
		}

		const btn = hubConfigsForm.querySelector( '#snapshot-configs--hub__apply' );
		btn.classList.add( 'sui-button-onload-text' );
		applying = true;

		const data = {
			nonce: hubConfigsForm.querySelector( '#snapshot-fetch-nonce' ).value,
			configId: hubConfigsForm.querySelector( '#snapshot-configs--hub' ).value
		};


		const check = checkRegion( data );
		check.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( ! result.success || result.data.message === 'region_mismatch' ) {
					// Close current modal.
					SUI.closeModal();
					const sel = document.querySelector( '#snapshot-configs-apply-region-change-modal' );
					sel.querySelector( '.snapshot-apply-config__confirm-region-change' ).setAttribute( 'data-config_id', data.configId );
					sel.querySelector( '.snapshot-apply-config__confirm-region-change' ).setAttribute( 'data-nonce', result.data.nonce );
					const replaced = sel.innerHTML.replace( '{{config_name}}', result.data.config_name );
					sel.innerHTML = replaced;
					SUI.openModal( 'snapshot-configs-apply-region-change-modal', window );
					btn.classList.remove( 'sui-button-onload-text' );
					applying = false;
					return;
				}

				// We're not applying the config yet.
				if ( result.data.message === 'region_match' ) {
					const applyConfigForm = new FormData();
					applyConfigForm.append( 'action', 'snapshot_apply_config' );
					applyConfigForm.append( 'id', data.configId );
					applyConfigForm.append( '_ajax_nonce', result.data.nonce );
					applyConfig( applyConfigForm, btn );
				}
			});
	} );
}

const confirmApplyConfigRegionChange = document.querySelector( '.snapshot-apply-config__confirm-region-change' );
if ( confirmApplyConfigRegionChange ) {
	document.addEventListener( 'click', ( e ) => {
		const el = e.target;

		if ( ! el || ! el.classList.contains( 'snapshot-apply-config__confirm-region-change' ) ) {
			return;
		}

		if ( applying ) {
			return;
		}

		applying = true;
		el.classList.add( 'sui-button-onload-text' );
		// Maybe implement the loader to indicate that the config is being applied.
		const applyConfigFormData = new FormData();
		applyConfigFormData.append( 'action', 'snapshot_apply_config' );
		applyConfigFormData.append( 'id', el.getAttribute( 'data-config_id' ) );
		applyConfigFormData.append( '_ajax_nonce', el.getAttribute( 'data-nonce' ) );
		applyConfig( applyConfigFormData, el );
	} );
}

const regionChangeConfirmModal = document.querySelector( '#snapshot-configs-apply-region-change-modal' );
if ( regionChangeConfirmModal ) {
	regionChangeConfirmModal.addEventListener( 'click', ( e ) => {
		const el = e.target;

		if ( el.hasAttribute( 'data-modal-close' ) || el.closest( 'button' ).hasAttribute( 'data-modal-close' ) ) {
			SUI.closeModal();
		}
	} );
}

const googleLoginForm = document.querySelector( '#snapshot-google-login' );
googleLoginForm.addEventListener( 'submit', ( e ) => {
	e.preventDefault();
	let redirectUrl = googleLoginForm.querySelector( '[name=redirect_url]' ).value;
	const what = googleLoginForm.querySelector( '[name=what]' ).value;

	if ( what ) {
		redirectUrl += `&action=${ what }`;
	}

	googleLoginForm.querySelector( '[name=redirect_url]' ).value = redirectUrl;

	googleLoginForm.submit();
} );

( function( $ ) {
	if ( ! ( urlSearchParams.has( 'action' ) ) ) {
		if ( ( $( '#snapshot-welcome-dialog' ).length > 0 ) && ! ( $( '#snapshot-welcome-dashboard-dialog' ).length > 0 ) ) {
			const listen = setInterval( function() {
				SUI.openModal( 'snapshot-welcome-dialog', window, undefined, false, false );
				clearInterval( listen );
			}, 500 );
		}

		if ( $( '#snapshot-welcome-dashboard-dialog' ).length > 0 ) {
			const listen = setInterval( function() {
				SUI.openModal( 'snapshot-welcome-dashboard-dialog', window, undefined, false, false );
				clearInterval( listen );
			}, 500 );
		}
	}


	/**
	 * Sends an AJAX Request to change the storage limit.
	 *
	 * @param {*} el   Main "Save Changes" button.
	 * @param {*} args AJAX data arguments.
	 *
	 * @return {bool|XMLHttpRequest}
	 */
	function change_storage_limit( el = null, args = null ) {
		if ( null === args ) {
			return false;
		}

		if ( null === el ) {
			return false;
		}

		return $.ajax( {
			type: 'POST',
			url: ajaxurl,
			data: args,
			beforeSend() {
				el.find( '.sui-button' ).prop( 'disabled', true );
			}
		} );
	}

	/**
	 * Handles saving settings
	 *
	 * @param {Object} e Event object
	 */
	function handle_save_settings( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}

		const data = {};
		$( this ).serializeArray().forEach( function( item ) {
			data[ item.name ] = item.value;
		} );
		data._wpnonce = $( '#_wpnonce-save_snapshot_settings' ).val();

		if ( 'snapshot-backup-limit' in data ) {
			if (
				! $.isNumeric( data[ 'snapshot-backup-limit' ] ) ||
				data[ 'snapshot-backup-limit' ] < 1 ||
				data[ 'snapshot-backup-limit' ] > 30
			) {
				$( '#error-snapshot-backup-limit' ).show();
				$( '#error-snapshot-backup-limit' ).html( snapshot_messages.storage_limit_invalid );
				$( '.snapshot-storage-limit-input .sui-form-field' ).addClass( 'sui-form-field-error' );
				$( '#snapshot-backup-limit' ).trigger( 'focus' );

				return false;
			}
			$( '#error-snapshot-backup-limit' ).html( '' );
			$( '#error-snapshot-backup-limit' ).hide();
			$( '.snapshot-storage-limit-input .sui-form-field' ).removeClass( 'sui-form-field-error' );
		}

		const that = $( this );

		const global_exclusions_el = that.find( '.sui-multistrings-list' );

		if ( global_exclusions_el.length ) {
			const items = [];
			global_exclusions_el.children( 'li:not(.sui-multistrings-input)' ).each( function() {
				items.push( $( this ).attr( 'title' ) );
			} );
			data.global_exclusions = JSON.stringify( items );
		}

		const db_tables = document.querySelectorAll( '.snapshot-tables-listitem' );
		const filtered_tables = [];
		if ( db_tables.length ) {
			db_tables.forEach( function( el ) {
				if ( el.getAttribute( 'aria-selected' ) === 'true' ) {
					filtered_tables.push( el.dataset.table_name );
				}
			} );
		}

		data['snapshot-excluded-tables'] = filtered_tables.length == 0 ? '[]' : filtered_tables;

		$.ajax( {
			type: 'POST',
			url: ajaxurl,
			data,
			beforeSend() {
				that.find( '.sui-button' ).prop( 'disabled', true );
			},
			success( result ) {
				if ( result.success ) {
					// We have to send another AJAX request if response has 'continue_ajax' flag.
					if ( 'continue_ajax' in result.data && result.data.continue_ajax ) {
						if ( 'change_storage_limit' === result.data.next_action ) {
							// Send another AJAX request to update the storage limit via API.
							const newAjax = change_storage_limit( that, result.data.next_args );

							newAjax.done( ( nResult ) => {
								if ( nResult.success ) {
									that.find( '#existing_backup_limit' ).val( nResult.data.changed_storage );
									jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.settings_save_success, 3000, false ] );
								} else {
									jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.settings_save_error ] );
								}
							} );
							newAjax.always( () => {
								that.find( '.sui-button' ).prop( 'disabled', false );
							} );
							newAjax.fail( () => {
								jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.settings_save_error ] );
							} );
						}
					} else {
						that.find( '.sui-button' ).prop( 'disabled', false );
						jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.settings_save_success, 3000, false ] );
					}
				} else {
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.settings_save_error ] );
				}
			},
			error() {
				jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.settings_save_error ] );
			}
		} );
		return false;
	}

	function handle_save_backup_settings( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}

		const data = {};
		$( this ).serializeArray().forEach( function( item ) {
			data[ item.name ] = item.value;
		} );

		const that = $( this );

		const frequency = that.find( '.sui-side-tabs>div[data-tabs]>div.active' ).data( 'frequency' );

		let request_data = {
			action: 'snapshot-backup_schedule',
			schedule_action: data.schedule_action,
			_wpnonce: $( '#_wpnonce-backup_schedule' ).val(),
			//apply_exclusions: data.apply_exclusions === 'on',
			data: {
				frequency,
				status: data.status,
				files: data.files,
				tables: data.tables,
				frequency_weekday: null,
				frequency_monthday: null,
				time: null
			}
		};

		switch ( frequency ) {
			case 'daily':
				request_data.data.time = data.daily_time;
				break;
			case 'weekly':
				request_data.data.time = data.weekly_time;
				request_data.data.frequency_weekday = parseInt( data.frequency_weekday );
				break;
			case 'monthly':
				request_data.data.time = data.monthly_time;
				request_data.data.frequency_monthday = parseInt( data.frequency_monthday );
				break;
		}

		request_data.data = JSON.stringify( request_data.data );

		if ( ! frequency || ( e.data && 'delete' === e.data.schedule_action ) ) {
			request_data = {
				action: 'snapshot-backup_schedule',
				schedule_action: 'delete',
				_wpnonce: $( '#_wpnonce-backup_schedule' ).val()
			};
		}

		$.ajax( {
			type: 'POST',
			url: ajaxurl,
			data: request_data,
			beforeSend() {
				that.find( '.sui-button' ).addClass( 'sui-button-onload-text' );
			},
			complete() {
				that.find( '.sui-button' ).removeClass( 'sui-button-onload-text' );
			},
			success( data ) {
				close_modal();
				if ( ! data.success ) {
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.schedule_save_error ] );
					return;
				}
				$( window ).trigger( 'snapshot:get-schedule' );
				if ( that.data( 'showScheduleNotice' ) ) {
					if ( data.data.schedule.values.frequency === null ) {
						close_welcome_schedule_modal();
						return;
					}

					const notice = $( '<span></span>' );
					const notice_html = [
						snapshot_messages.schedule_backup_time.replace( '%s', data.data.schedule.text ),
						snapshot_messages.schedule_next_backup_time.replace( '%s', data.data.schedule.next_backup_time ),
					].join( ' ' );
					notice.append( notice_html );
					notice.find( 'a' ).on( 'click', function( e ) {
						goto_manual_backup_modal( e, notice );
					} );
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', notice ] );

					showWhatsNewModal();
				} else if ( request_data.schedule_action === 'create' ) {
					let create_message = snapshot_messages.schedule_backup_time
						.replace( '%s', data.data.schedule.text );
					create_message += ' ' + snapshot_messages.schedule_next_backup_time
						.replace( '%s', data.data.schedule.next_backup_time ),
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'info', create_message ] );
				} else if ( request_data.schedule_action === 'update' ) {
					let update_message = snapshot_messages.schedule_update_time
						.replace( '%s', data.data.schedule.text );
					update_message += ' ' + snapshot_messages.schedule_next_backup_time
						.replace( '%s', data.data.schedule.next_backup_time ),
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'info', update_message ] );
				} else if ( request_data.schedule_action === 'delete' ) {
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'info', snapshot_messages.schedule_delete ] );
				}
			},
			error() {
				jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.schedule_save_error ] );
			}
		} );
	}

	function close_welcome_schedule_modal() {
		close_modal();

		const notice = $( '<span></span>' ).html( snapshot_messages.onboarding_schedule_close );
		const a = notice.find( 'a' );
		a.eq( 0 ).on( 'click', function( e ) {
			goto_manual_backup_modal( e, notice );
		} );
		a.eq( 1 ).on( 'click', function( e ) {
			goto_set_schedule_modal( e, notice );
		} );

		jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', notice ] );

		showWhatsNewModal();
	}

	function boot_settings_handler() {
		$( '#wps-settings' ).on( 'submit', handle_save_settings );
		$( '#form-snapshot-schedule' ).on( 'submit', handle_save_backup_settings );
		$( '#onboarding-schedule' ).on( 'submit', handle_save_backup_settings );
		$( '#snapshot-welcome-dialog-slide-3 .close-modal' ).on( 'click', close_welcome_schedule_modal );
		$( '#create-backup-link' ).on( 'click', function() {
			$( window ).trigger( 'snapshot:backup_modal' );
			$( this ).trigger( 'snapshot:close_notice' );
		} );
	}

	function on_snapshot_manual_backup_modal( e ) {
		if ( $( '#snapshot-php-version' ).val() < 0 ) {
			// We dont have a compatible PHP version, show the requirement check modal.
			SUI.openModal( 'modal-snapshot-requirements-check-failure', this );
			return false;
		}

		$( '#form-snapshot-create-manual-backup input[type=text]' ).val( '' );
		SUI.openModal( 'modal-snapshot-create-manual-backup', this );
		$( '#modal-snapshot-create-manual-backup #manual-backup-name' ).trigger( 'focus' );
		return false;
	}

	function schedule_modal( e, action, values, schedule_action ) {
		const form = $( '#form-snapshot-schedule' );

		form.find( '.sui-button' ).prop( 'disabled', false );

		form.find( 'input[type=text]' ).val( '' );

		if ( 'update' === action ) {
			form.find( '[data-tabs]>div' ).each( function() {
				const $this = $( this );
				if ( $this.data( 'frequency' ) === values.frequency ) {
					$this.trigger( 'click' );
				}
			} );
			if ( values.time ) {
				form.find( 'select[name=daily_time]' ).val( values.time );
				form.find( 'select[name=weekly_time]' ).val( values.time );
				form.find( 'select[name=monthly_time]' ).val( values.time );
			}
			if ( values.frequency_weekday ) {
				form.find( 'select[name=frequency_weekday]' ).val( values.frequency_weekday );
			}
			if ( values.frequency_monthday ) {
				form.find( 'select[name=frequency_monthday]' ).val( values.frequency_monthday );
			}
			form.find( 'select' ).trigger( 'change' );
		}

		let open = true;
		if ( 'create' === action ) {
			form.find( 'input[name=schedule_action]' ).val( 'create' );
		} else if ( 'update' === action ) {
			form.find( 'input[name=schedule_action]' ).val( 'update' );
		} else {
			open = false;
		}
		if ( schedule_action ) {
			form.find( 'input[name=schedule_action]' ).val( schedule_action );
		}
		if ( open ) {
			SUI.openModal( 'modal-snapshot-edit-schedule', this );
		}
	}

	function on_show_top_notice( e, type, text, close_after, can_dismiss ) {
		if ( can_dismiss === undefined ) {
			can_dismiss = true;
		}
		if ( close_after === undefined ) {
			close_after = false;
		}

		let icon = 'info';
		switch ( type ) {
			case 'success':
				icon = 'check-tick';
				break;
			case 'warning':
			case 'error':
				icon = 'warning-alert';
				break;
		}

		let notice_container = $( '.sui-floating-notices' ).eq( 0 );
		if ( ! notice_container.length ) {
			notice_container = $( '<div class="sui-floating-notices"></div>' );
			notice_container.insertAfter( $( '.sui-header' ).eq( 0 ) );
		}

		// Generate random id
		const notice_id = 'snapshot-notice-' + Math.random().toString( 36 ).substr( 2, 9 );
		const notice = $( '<div role="alert" id="' + notice_id + '" class="sui-notice" aria-live="assertive"></div>' );
		notice.appendTo( notice_container );
		const notice_options = { type, icon };
		if ( close_after ) {
			notice_options.autoclose = { timeout: close_after };
		} else {
			notice_options.autoclose = { show: false };
		}
		if ( can_dismiss ) {
			notice_options.dismiss = { show: true };
		}
		if ( text instanceof jQuery ) {
			SUI.openNotice( notice_id, '<p></p>', notice_options );
			$( '#' + notice_id ).find( '.sui-notice-message>p' ).append( text );
		} else {
			SUI.openNotice( notice_id, '<p>' + $( '<p></p>' ).text( text ).html() + '</p>', notice_options );
		}

		notice.on( 'snapshot:close_notice', function() {
			SUI.closeNotice( notice_id );
		} );
	}

	function goto_manual_backup_modal( e, notice ) {
		e.preventDefault();
		notice.trigger( 'snapshot:close_notice' );

		// Lets see if we're on the backups page.
		$.urlParam = function( name ) {
			const results = new RegExp( '[\?&]' + name + '=([^&#]*)' ).exec( window.location.href );
			return results[ 1 ] || 0;
		};
		if ( $.urlParam( 'page' ) && 'snapshot-backups' === $.urlParam( 'page' ) ) {
			jQuery( window ).trigger( 'snapshot:backup_modal' );
		} else {
			window.location = snapshot_urls.backups + '#create-backup';
		}
	}

	function goto_set_schedule_modal( e, notice ) {
		e.preventDefault();
		notice.trigger( 'snapshot:close_notice' );

		// Lets see if we're on the backups page.
		$.urlParam = function( name ) {
			const results = new RegExp( '[\?&]' + name + '=([^&#]*)' ).exec( window.location.href );
			return results[ 1 ] || 0;
		};

		if ( $.urlParam( 'page' ) && 'snapshot-backups' === $.urlParam( 'page' ) ) {
			$( '#snapshot-backup-schedule > a' ).trigger( 'click' );
		} else {
			window.location = snapshot_urls.backups + '#set-schedule';
		}
	}

	function install_dashboard( e, installed ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}

		const data = {
			_wpnonce: $( '#_wpnonce-snapshot_install_dashboard' ).val(),
			action: 'snapshot-handle_dashboard',
			installed: installed ? 1 : 0
		};

		$.ajax( {
			type: 'POST',
			url: ajaxurl + '?action=snapshot-handle_dashboard',
			data,
			beforeSend() {
				$( '#snapshot-welcome-dashboard-dialog' ).find( '.sui-button' ).addClass( 'sui-button-onload-text', true );
			},
			success( response ) {
				if ( response.success ) {
					if ( 'activation' === response.data.action ) {
						// Checked in PHP after activation, whether we're logged in or not. If we are, no need to redirect.

						if ( false !== response.data.redirect_to ) {
							window.location.href = response.data.redirect_to;
						} else {
							$( '#snapshot-welcome-dashboard-dialog' ).find( '.sui-button' ).removeClass( 'sui-button-onload-text', false );

							close_modal();
							if ( true === response.data.welcome_modal ) {
								const listen = setInterval( function() {
									SUI.openModal( 'snapshot-welcome-dialog', this, undefined, false, false );
									clearInterval( listen );
								}, 500 );
							}

							if ( response.data.reactivate_membership ) {
								show_membership_expired_modal( true );
							}
						}
					} else if ( 'installation' === response.data.action ) {
						let redirect_to = snapshot_urls.install_dashboard + '&plugin=install_wpmudev_dash&_wpnonce=' + response.data.nonce;
						window.location.href = redirect_to;
					}
				}
			}
		} );
	}

	function reactivate_schedule() {
		const data = {};

		data._wpnonce = $( '#_wpnonce-reactivate_snapshot_schedule' ).val();

		const url = ajaxurl + '?action=reactivate_snapshot_schedule';

		const modal = $( '#snapshot-welcome-dialog' );

		function onError() {
			modal.find( '.on-error' ).show();
			modal.find( '.on-success' ).hide();
		}

		$.ajax( {
			type: 'POST',
			url,
			data,
			cache: false,
			dataType: 'json',
			beforeSend() {
				$( '#snapshot-welcome-dialog .sui-button' ).prop( 'disabled', true );
			},
			complete() {
				$( '#snapshot-welcome-dialog .sui-button' ).prop( 'disabled', false );
			},
			success( response ) {
				if ( ! response.success ) {
					onError();
					return;
				}

				modal.find( '.on-success' ).show();
				modal.find( '.on-error' ).hide();

				$( window ).trigger( 'snapshot:get-schedule' );

				if ( response.data.show_schedule_modal === true ) {
					// We have a region selected already, so we skip the region modal.
					SUI.slideModal( 'snapshot-welcome-dialog-slide-3' );

					// We also hide the X button on the schedule modal.
					$( '#snapshot-welcome-dialog-slide-3 .hide-when-region-selected' ).hide();
				} else {
					// We have a region selected already AND an active schedule, so we all next modals.
					close_modal();
					showWhatsNewModal();
				}
			},
			error() {
				onError();
			}
		} );

		return false;
	}

	function save_region( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
		const data = {};

		data._wpnonce = $( '#_wpnonce-save_snapshot_region' ).val();
		data.region = $( '#onboarding-select-region option:selected' ).val();

		const url = ajaxurl + '?action=save_snapshot_region';

		const modal = $( '#snapshot-welcome-dialog' );

		function onError() {
			modal.find( '.on-error' ).show();
		}

		$.ajax( {
			type: 'POST',
			url,
			data,
			cache: false,
			dataType: 'json',
			beforeSend() {
				$( '#snapshot-set-initial-region' ).prop( 'disabled', true );
				$( '#snapshot-set-initial-region' ).addClass( 'sui-button-onload-text', true );
				modal.find( '.on-error' ).hide();
			},
			complete() {
				$( '#snapshot-set-initial-region' ).prop( 'disabled', false );
				$( '#snapshot-set-initial-region' ).removeClass( 'sui-button-onload-text', true );
			},
			success( response ) {
				if ( response.success ) {
					SUI.slideModal( 'snapshot-welcome-dialog-slide-3' );

					if ( response.data.selected_region === 'US' ) {
						$( '#backup-region-us' ).prop( 'checked', true );
						$( '#backup-region-eu' ).prop( 'checked', false );
					} else if ( response.data.selected_region === 'EU' ) {
						$( '#backup-region-eu' ).prop( 'checked', true );
						$( '#backup-region-us' ).prop( 'checked', false );
					}
				} else {
					onError();
				}
			},
			error() {
				onError();
			}
		} );

		return false;
	}

	function close_modal() {
		try {
			SUI.closeModal();
		} catch ( e ) {
		}
	}

	function move_to_region_modal() {
		SUI.slideModal( 'snapshot-welcome-dialog-slide-2' );
	}

	function toggle_cooldown( e, time_elapsed ) {
		if ( time_elapsed < 1 ) {
			$( '.sui-tooltip.snapshot-cooldown' ).show();
			$( '.sui-button.snapshot-not-cooldown' ).hide();
			setTimeout( function() {
				toggle_cooldown( e, 1 );
			}, ( 1 - time_elapsed ) * 1000 * 60 );
		} else {
			$( '.sui-tooltip.snapshot-cooldown' ).hide();
			$( '.sui-button.snapshot-not-cooldown' ).show();
		}
	}

	function uninstall_snapshot_v3( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}

		const data = {
			_wpnonce: $( '#_wpnonce-uninstall_snapshot_v3' ).val(),
		};

		$.ajax( {
			type: 'POST',
			url: ajaxurl + '?action=snapshot-uninstall_snapshot_v3',
			data,
			beforeSend() {
				$( '.snapshot-uninstall-v3' ).addClass( 'sui-button-onload-text', true );
			},
			success( response ) {
				$( '.snapshot-uninstall-v3' ).removeClass( 'sui-button-onload-text', true );
				close_modal();
				if ( response.success ) {
					SUI.closeNotice( 'snapshot-uninstall-v3' );
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.snapshot_v3_uninstall_success ] );

					$( '.wp-has-submenu.toplevel_page_snapshot_pro_dashboard' ).hide();
				}
			},
			error() {
				$( '.snapshot-uninstall-v3' ).removeClass( 'sui-button-onload-text', true );
				close_modal();
			}
		} );
	}

	function check_if_region_modal( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}

		const data = {
			_wpnonce: $( '#_wpnonce-snapshot_check_if_region' ).val(),
		};

		const modal = $( '#snapshot-welcome-dialog' );
		const buttons = modal.find( '.snapshot-get-started' );

		function onError() {
			modal.find( '.on-error' ).show();
			modal.find( '.on-success' ).hide();
		}

		$.ajax( {
			type: 'POST',
			url: ajaxurl + '?action=snapshot-check_creds',
			data,
			beforeSend() {
				buttons.addClass( 'sui-button-onload-text' );
				modal.find( '.on-error' ).hide();
				modal.find( '.on-success' ).show();
			},
			complete() {
				buttons.removeClass( 'sui-button-onload-text' );
			},
			success( response ) {
				if ( ! response.success ) {
					onError();
					return;
				}

				if ( response.success ) {
					if ( response.data.region === null ) {
						$( window ).trigger( 'snapshot:move_to_region_modal' );
					} else {
						$( window ).trigger( 'snapshot:reactivate_schedule' );
					}
				}
			},
			error() {
				onError();
			}
		} );
	}

	function uninstall_v3_confirm() {
		SUI.openModal( 'modal-confirm-v3-uninstall', this );
		return false;
	}

	function on_click_whats_new_link() {
		const url = new URL( $( this ).attr( 'href' ) );
		if ( url.hash === '#notifications' && $( '.snapshot-page-backups' ).length ) {
			$( window ).trigger( 'snapshot:close_modal' );
			$( '.snapshot-page-main' ).find( '.snapshot-notifications' ).show();
			$( '.snapshot-page-main' ).find( '.snapshot-list-backups' ).hide();
			$( '.snapshot-page-main' ).find( '.snapshot-vertical-notifications' ).addClass( 'current' );
			$( '.snapshot-page-main' ).find( '.snapshot-vertical-backups' ).removeClass( 'current' );
			$( '.snapshot-page-main select.sui-mobile-nav' ).val( 'notifications' ).change();
			return false;
		}
	}

	function show_membership_expired_modal( no_check_dashboard ) {
		if ( no_check_dashboard === undefined ) {
			no_check_dashboard = false;
		}
		if ( ! no_check_dashboard && $( '#snapshot-welcome-dashboard-dialog' ).length ) {
			return;
		}
		if ( $( '#snapshot-membership-expired-modal' ).length ) {
			SUI.openModal( 'snapshot-membership-expired-modal', this );
		}
	}

	function click_whats_new_modal_button_ok() {
		const a = $( this );
		const href = a.attr( 'href' );
		if ( href && href !== window.location.href ) {
			window.location = href;
		}
	}

	function hide_double_tooltip() {
		$( '.snapshot-export-failure' ).on( 'mouseenter', function() {
			$( this ).parent().addClass( 'snapshot-tooltip-hover' );
		} ).on( 'mouseleave', function() {
			$( this ).parent().removeClass( 'snapshot-tooltip-hover' );
		} );
	}

	function close_tutorials_slider() {
		$( '#snapshot-tutorials-slider' ).closest( '.sui-row' ).remove();

		$.ajax( {
			type: 'POST',
			url: ajaxurl + '?action=snapshot-tutorials_slider_seen',
			data: {
				_wpnonce: $( '#_wpnonce-tutorials_slider_seen' ).val()
			}
		} );
	}

	function sui_tabs_callback( tab ) {
		if ( $( tab ).closest( '#modal-snapshot-edit-schedule' ) && ! snapshot_env.values.is_pro ) {
			let frequency = $( tab ).data( 'frequency' );
			let submit_button = $( '#modal-snapshot-edit-schedule button[type=submit]' );
			if ( frequency === 'daily' || frequency === 'weekly' ) {
				$( '#snapshot-notice-tpd-schedule' ).hide();
				submit_button.prop( 'disabled', true );
			} else {
				$( '#snapshot-notice-tpd-schedule' ).show();
				submit_button.prop( 'disabled', false );
			}
		}

		if ( $( tab ).closest( '#snapshot-welcome-dialog' ) && ! snapshot_env.values.is_pro ) {
			let frequency = $( tab ).data( 'frequency' );
			let submit_button = $( '#snapshot-welcome-dialog button[type=submit]' );
			if ( frequency === 'daily' || frequency === 'weekly' ) {
				submit_button.prop( 'disabled', true );
			} else {
				submit_button.prop( 'disabled', false );
			}
		}
	}

	$( function() {
		boot_settings_handler();
		$( window ).on( 'snapshot:backup_modal', on_snapshot_manual_backup_modal );
		$( window ).on( 'snapshot:reactivate_schedule', reactivate_schedule );
		$( window ).on( 'snapshot:save_region', save_region );
		$( window ).on( 'snapshot:move_to_region_modal', move_to_region_modal );
		$( window ).on( 'snapshot:schedule', schedule_modal );
		$( window ).on( 'snapshot:show_top_notice', on_show_top_notice );
		$( window ).on( 'snapshot:install_dashboard', install_dashboard );
		$( window ).on( 'snapshot:close_modal', close_modal );
		$( window ).on( 'snapshot:toggle_cooldown', toggle_cooldown );
		$( window ).on( 'snapshot:uninstall_snapshot_v3', uninstall_snapshot_v3 );
		$( window ).on( 'snapshot:check_if_region_modal', check_if_region_modal );
		$( window ).on( 'snapshot:hide_double_tooltip', hide_double_tooltip );
		$( window ).on( 'snapshot:close_tutorials_slider', close_tutorials_slider );

		if ( '#create-backup' === window.location.hash ) {
			jQuery( window ).trigger( 'snapshot:backup_modal' );
			if ( window.history && window.history.replaceState ) {
				window.history.replaceState( '', document.title, window.location.pathname + window.location.search );
			}
		}

		$( '#snapshot-uninstall-v3-confirm' ).on( 'click', uninstall_v3_confirm );

		$( '#snapshot-whats-new-modal .sui-box-header .sui-description>a' ).on( 'click', on_click_whats_new_link );
		$( window ).on( 'snapshot:show_whats_new_modal', showWhatsNewModal );
		$( '#snapshot-whats-new-modal-button-ok' ).on( 'click', click_whats_new_modal_button_ok );
		if ( ! $( '#snapshot-welcome-dialog' ).length ) {
			showWhatsNewModal();
		}

		show_membership_expired_modal();

		SUI.suiTabs( { callback: sui_tabs_callback } );
	} );
}( jQuery ) );

/**
 * Closes the modal when 'esc' key is pressed.
 */
document.addEventListener( 'keyup', ( e ) => {
	if ( e.key && 'undefined' !== e.key && 'escape' === e.key.toLowerCase() ) {
		const activeModal = document.querySelector( '.sui-active' );
		if ( activeModal && activeModal.classList.contains( 'sui-modal' ) ) {
			const $close = activeModal.querySelector( 'button[data-modal-close]' );
			if ( $close ) {
				$close.click();
				window.SUI.closeModal();
			}
		}
	}
} );

if ( 'notify' in snapshot_messages && snapshot_messages.notify ) {
	openNotice( {
		message: snapshot_messages.notification_text,
		type: 'warning',
		dismissible: true,
		id: 'snapshot-scheduled-backups-failed'
	} );
}

const backupsPage = document.querySelector( '.snapshot-page-backups' );
if ( backupsPage ) {
	backupsPage.addEventListener( 'click', function( e ) {
		const el = e.target;
		const win = window;
		if ( el.classList.contains( 'blue-link' ) ) {
			e.preventDefault();
			SUI.closeNotice( 'snapshot-scheduled-backups-failed' );
			setTimeout( () => {
				SUI.openModal( 'modal-snapshot-create-manual-backup', win );
			}, 500 );
		}
	} );
}
Explorer.init();

/*
|--------------------------------------------------------------------------
| Apply config after Google Login
|--------------------------------------------------------------------------
*/
if ( urlSearchParams.has( 'referer' ) && 'google_login' === urlSearchParams.get( 'referer' ) ) {
	if ( urlSearchParams.has( 'set_apikey' ) && snapshotReact.requestsData.apiKey === urlSearchParams.get( 'set_apikey' ) ) {
		if ( urlSearchParams.has( 'action' ) && urlSearchParams.get( 'action' ).includes( 'apply_config_' ) ) {
			const current = document.querySelector( '.snapshot-page-settings .sui-vertical-tabs .current' );
			if ( current ) {
				current.classList.remove( 'current' );
				document.querySelector( '.snapshot-vertical-configs' ).classList.add( 'current' );

				document.querySelector( '.snapshot-tab.snapshot-tab-api-key' ).style.display = 'none';
				document.querySelector( '.snapshot-tab.snapshot-tab-configs' ).style.display = 'block';
			}

			const action = urlSearchParams.get( 'action' );
			const config = action.split( 'apply_config_' );

			const config_id = parseInt( config[ 1 ] );

			const configModal = document.querySelector( '#snapshot-configs-apply-final' );
			const configConfirm = configModal.querySelector( '.snapshot-apply-config__final-action' );
			configConfirm.classList.add( 'sui-button-onload' );

			SUI.openModal( 'snapshot-configs-apply-final', window );

			const cfg = new Config();
			cfg.applyConfigAfterGoogleLogin( config_id, 'modal' );
		}
	}
}
